import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=2b3b6251&scoped=true&"
import script from "./about-me.vue?vue&type=script&lang=js&"
export * from "./about-me.vue?vue&type=script&lang=js&"
import style0 from "./about-me.vue?vue&type=style&index=0&id=2b3b6251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b6251",
  null
  
)

export default component.exports